export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12824.6f25722e.jpg";